module.exports = __webpack_public_path__ + "img/banner-jupiler.c72af13a.png";